import type { QuickReply } from "../lib/types";

type QuickRepliesProps = {
  quickReplies: QuickReply[];
  disabled: boolean;
  onSelect: (quickReplyId: string, label: string) => void;
};

export default function QuickReplies({ quickReplies, disabled, onSelect }: QuickRepliesProps) {
  return (
    <div className="qk-chatbot-quick-replies" aria-label="Questions rapides">
      {quickReplies.map((quickReply) => (
        <button
          key={quickReply.id}
          className="qk-chatbot-quick-reply"
          type="button"
          disabled={disabled}
          onClick={() => onSelect(quickReply.id, quickReply.label)}
        >
          {quickReply.label}
        </button>
      ))}
    </div>
  );
}
